import {uuid} from 'uuidv4';
import Dispatchable from "utils/Dispatchable.js";
import {setPads, setPadSlots} from 'actions/index.js';
import Pad from './Pad.js';

export default superclass => class extends superclass {

    pads = [];

    async loadPackAsPads(pads) {
        let newPad = this.createPad();
        for (let i=0; i < pads.length; i++) {
            let content = pads[i];
            if (!content) {
                continue;
            }
            let track = await this.sequencerEngine.loadTrackPreset(
                content.preset,
                undefined,
                true);
            newPad.addTrack(track, i);
        }
    }

    deletePad(pad) {
        this.pads = this.pads.filter(p => p !== pad);
        pad.slotTracks.forEach(
            track => track.pad = undefined);
        this.updateRedux();
    }

    deleteTrackFromPads(track) {
        let pad = this.pads.find(
            x => x.slots.includes(track));
        if (!pad) {
            return;
        }
        pad.deleteTrack(track);
    }

    createPad(fromTracks, createRack) {
        let pad = new Pad(this, createRack);
        this.pads = [... this.pads, pad];
        if (fromTracks) {
            let slot=0;
            for (let track of this.tracks) {
                if (!track.pad) {
                    pad.addTrack(track, slot++);
                }
                if (slot >= 9) {
                    slot = 0;
                    pad = new Pad(this);
                    this.pads = [... this.pads, pad];
                }
            }
        }
        this.updateRedux();
        return pad;
    }

    updateRedux() {
        this.dispatch(
            setPads(
                this.id, this.pads));
    }

    getPadsJson() {
        return this.pads.map(p => p.getJson());
    }

    loadPadsJson(json) {
        if (!json) {
            return;
        }
        for (let _pad of json) {
            let pad = this.createPad(undefined, false);
            pad.fromJson(_pad);
        }
    }

    addTrackToPadIfPossible(track) {
        for (let pad of this.pads) {
            let index = pad.tracks.indexOf(false);
            if (index > -1 &&
                !pad.tracks.includes(track)) {
                pad.addTrack(track, index, true);
                return;
            }
        }
    }
}

// setPadTracks (pad id -> tracks)
// setPads (sub id -> pads)
